import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

import { colors, px, fontFamilySize } from '../../../../../contrib/ui';

export const TeeBoxAssignmentsStyled = styled(Paper)`
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: 0.3s;

  p {
    min-height: 0;
    margin: 0;
  }

  label {
    margin-right: ${px(50)};

    span:nth-child(2) {
      ${fontFamilySize('Bold', 14)}
      color: ${colors.dark};
    }

    svg {
      font-size: ${px(24)};
    }
  }

  .flights-options {
    flex-direction: column;
    align-items: flex-start !important;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    transition-delay: '0.5s';

    .set-ranges {
      .yes-no-switch {
        &__tag {
          @media (--s-d-viewport) {
            font-size: ${px(13)};
          }
        }
      }
    }

    .flights {
      width: 100%;
    }
  }

  .add-button {
    margin-bottom: 0;
    margin-top: ${px(23)};
    padding: 0 ${px(10)};
    width: initial;

    svg {
      font-size: ${px(26)};
      border-radius: 50%;
      margin-right: ${px(5)};
    }

    .add-button-text {
      font-size: ${px(16)};
      padding-top: ${px(3)};
    }

    &.button--disabled {
      svg,
      .add-button-text {
        color: ${colors.greyd8};
      }
    }
  }
`;
